// deno-fmt-ignore-file
import { Deferred } from '../types/deferred.mjs';
import { Instantiate } from '../engine/instantiate.mjs';
/** Creates a deferred Required action. */
export function RequiredDeferred(type, options = {}) {
    return Deferred('Required', [type], options);
}
/** Applies a Required action to the given type. */
export function Required(type, options = {}) {
    return Instantiate({}, RequiredDeferred(type, options));
}
